import { MaintenanceVehicleValuesOperations } from "./maintenance-vehicle-values-operations.model";

export interface MaintenanceVehicleValues {
  mileage: number;
  mileageUnit: string;
  months: number;
  operations: MaintenanceVehicleValuesOperations[];
}